import React from 'react';
import styled from 'styled-components';
import { format } from 'modules/helpers/strings';
import Translations from 'modules/translations';
import { SvgSprite } from 'modules/svgSprite';
import { rem } from 'modules/helpers/style';
import { GA4Tracking } from 'modules/tracking/GA4';
import type { listTypeEnum } from '../../enums';
import type IButton from 'components/Button/shared/types/button';
import { Button } from 'components/Button';

const Inner = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Spacer = styled.span`
    flex: 0 1 100%;
`;

const Content = styled.span`
    display: flex;
    flex: 0 0 auto;
`;

const SvgArrow = styled(SvgSprite)`
    width: ${rem(15)};
    height: ${rem(15)};
    margin-left: ${rem(5)};
`;

interface IHitsTotalLink extends IButton {
    hitsTotal: number;
    url: string;
    listType: listTypeEnum;
    searchTerm?: string;
}

export default function HitsTotalLink({
    hitsTotal,
    url,
    listType,
    searchTerm,
    ...restProps
}: IHitsTotalLink): JSX.Element {
    const { className } = restProps;

    return (
        <Button
            {...restProps}
            className={`btn ${className}`}
            onClick={(): void => {
                window.location.href = url;
                GA4Tracking({
                    eventName: 'see_all_results',
                    context: 'search',
                    category: 'ecommerce',
                    eventParams: [
                        { param_name: 'search_type', param_value: 'quick_search' },
                        { param_name: 'search_term', param_value: searchTerm }
                    ]
                });
            }}
        >
            <Inner>
                <Spacer />
                <Content>{format(Translations.Website.SearchDialog.TotalHitsLink)(hitsTotal)}</Content>
                <Spacer>
                    <SvgArrow sprite="ArrowRight" />
                </Spacer>
            </Inner>
        </Button>
    );
}
